import React from "react";
import firebase from "../../firebase";
import { Menu, Icon, Input, Item, Container } from "semantic-ui-react";

class AddFriendButton extends React.Component {
  state = {
    currentUser : this.props.currentUser,
    user : this.props.user,
    usersRef: firebase.database().ref("users"),
    otherUsersFriends: [],
    otherUsersBlocked: [],
  };

  componentDidMount() {
      this.addListeners();
  }

  componentWillUnmount() {
    this.removeListeners();
  }

  removeListeners() {

  }

  addListeners() {
    let loadedFriends = [];
    this.state.usersRef
      .child(`${this.state.user.uid}/friends`)
      .on("child_added", (snap) => {
          let user = snap.val();
          user["uid"] = user.uid;
          user["added"] = false;
          user["key"] = snap.key;
          loadedFriends.push(user);
          this.setState({ otherUsersFriends: loadedFriends });
      });

    let loadedFrnds = [];
    this.state.usersRef
      .child(`${this.state.user.uid}/friends`)
      .on("child_removed", (snap) => {
          let user = snap.val();
          // console.log(user)
          user["uid"] = user.uid;
          loadedFrnds = this.state.otherUsersFriends.filter((f) => f.uid !== user.uid);
          this.setState({ otherUsersFriends: loadedFrnds });
      });
      
      let blocked = [];
      this.state.usersRef
        .child(`${this.state.user.uid}/blocked`)
        .on("child_added", (snap) => {
            let user = snap.val();
            user["uid"] = user.uid;
            user["added"] = false;
            user["key"] = snap.key;
            blocked.push(user);
            this.setState({ otherUsersBlocked: blocked });
        });
  
      let blockedList = [];
      this.state.usersRef
        .child(`${this.state.user.uid}/blocked`)
        .on("child_removed", (snap) => {
            let user = snap.val();
            // console.log(user)
            user["uid"] = user.uid;
            blockedList = this.state.otherUsersBlocked.filter((f) => f.uid !== user.uid);
            this.setState({ otherUsersBlocked: blockedList });
        });
  
  }

  addFriend(user) {
    let userToAdd = {...user}
    userToAdd.unread = false
    this.state.usersRef
      .child(`${this.state.currentUser.uid}/friends`)
      .push()
      .update(userToAdd)
      .then(() => {
        console.log("Friend added");
      })
      .catch((err) => console.error(err));
  }

  isCurrentUserFriend(){
    return this.state.otherUsersFriends.some((f) => {
        return f.uid === this.state.currentUser.uid;
      });
  }

  isCurrentUserBlocked(){
    return this.state.otherUsersBlocked.some((f) => {
        return f.uid === this.state.currentUser.uid;
      });
  }

  addCurrentUserAsFriend(user){
    let currentUser = this.state.currentUser;
    let userToAdd = {
        uid : currentUser.uid,
        name : currentUser.displayName,
        avatar : currentUser.photoURL,
        status:"offline",
        unread: false,
    }
    this.state.usersRef
    .child(`${user.uid}/friends`)
    .push()
    .update(userToAdd)
    .then(() => {
      console.log("Friend added");
    })
    .catch((err) => console.error(err));
  }

  userOnClick(user){
      this.addFriend(user)
      if( (!this.isCurrentUserBlocked()) && (!this.isCurrentUserFriend()) )
        this.addCurrentUserAsFriend(user)
  }

  render() {

    return (
        <Icon
            name="add"
            color="green"
            onClick={() => this.userOnClick(this.props.user)}
        />
          );
  }
}

export default AddFriendButton;



// WEBPACK FOOTER //
// ./src/components/MetaPanel/AddFriendButton.js